module.exports = __webpack_public_path__ + "img/pena-mas.697c944.png";